import { render, staticRenderFns } from "./NavbarButtonConfiguration.vue?vue&type=template&id=7c4e4d0a&scoped=true"
import script from "./NavbarButtonConfiguration.vue?vue&type=script&lang=js"
export * from "./NavbarButtonConfiguration.vue?vue&type=script&lang=js"
import style0 from "./NavbarButtonConfiguration.vue?vue&type=style&index=0&id=7c4e4d0a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4e4d0a",
  null
  
)

export default component.exports